jQuery(function($){
  if ($('.image-with-points').length){
    var side_margin = 12;
    $('.iwp-point-js').on('place-popin', function(){
      var $point = $(this);
      var $popin = $point.find('.iwp-popin-js');
      var $arrow = $point.find('.iwp__popin-arrow');

      if ($point.position().top / $point.parents('.iwp__img-cont').height() > 0.5){
        $popin.css('bottom', 'calc(100% - 0px)');
        $popin.css('top', '');
        $arrow.addClass('m--upper');
      }
      else {
        $popin.css('top', 'calc(100% - 0px)');
        $popin.css('bottom', '');
        $arrow.removeClass('m--upper');
      }

      if ($(window).width() >= 768){
        $popin.css('left', '50%');
        $arrow.css('left', '');
        if ($popin.offset().left - side_margin < $point.parents('.iwp__img-cont').offset().left){
          $popin.offset({ left: $point.parents('.iwp__img-cont').offset().left - side_margin });
        }
      } else {
        $popin.offset({left: $(window).width()/10});
      }
      $arrow.offset({ left:  $point.offset().left + $point.width()/2 - $arrow.width()/2});

    });
    $('.iwp-point-js').on('mouseenter', function(){
      $(this).addClass('is-opened');
      $(this).find('.iwp-popin-js').trigger('place-popin');
    });
    $('.iwp-point-js').on('mouseleave', function(){
      $(this).removeClass('is-opened');
    });
    $('.iwp-point-js').on('click', function(){
      if ($(this).hasClass('is-opened')){
        $('.iwp-point-js').removeClass('is-opened');
      }
      else{
        $('.iwp-point-js').removeClass('is-opened');
        $(this).addClass('is-opened');
      }
      $(this).find('.iwp-popin-js').trigger('place-popin');
    });
    $(window).on('resize', function(){
      $('.iwp-point-js').trigger('place-popin');
    });
    $('.iwp-point-js').trigger('place-popin');
  }
});